<template>
<v-container>
  <v-card
      class="mx-auto image-box"
      max-width="auto"
      v-if="post"
  >
    <v-img
        class=" white--text align-end"

        :src="post.url"
        contain

    >

    </v-img>

    <v-card-subtitle class="pb-0">{{ post.title | truncate(50)}}</v-card-subtitle>

    <v-card-text class="text--primary">
      <div>r/{{ post.subreddit }}</div>
    </v-card-text>

    <v-card-actions>
      <v-btn
          color="orange"
          text
          :href="`https://redd.it/` + post.post_id"
          target="_blank"
      >
        View Post
      </v-btn>

    </v-card-actions>
    <v-sheet
    >
      <div style="background: #1e1e1e;" class="rounded pa-3 text-center">
        <span v-html="imageHash"></span>
      </div>
    </v-sheet>
  </v-card>
</v-container>
</template>

<script>
export default {
  name: "CompareImageHolder",
  props: {
    post: Object,
    imageHash: String
  }
}
</script>

<style scoped>
.chardif {
  color: red;
}
.image-box {
  background: #303030;
}
</style>